import React from "react";
import { hot } from 'react-hot-loader';

import styles from './CheckDocxInterface.module.css';

const NATURE = "feature/basic/nature"
const FISHING = "feature/basic/social/fishing"
const DEMOGRAPHY = "feature/basic/social/demography"
const DISASTER_RESPONSE ="feature/basic/social/disaster_response"
const HISTORY_TEMP_YEARLY = "feature/history/temperature/yearly"
const HISTORY_TEMP_SUMMER_WINTER = "feature/history/temperature/summer_winter"
const HISTORY_PRECIPITATION = "feature/history/precipitation"
const FUTURE_TEMP_AVERAGE = "feature/future/temperature/average"
const FUTURE_TEMP_SUMMER_WINTER = "feature/future/temperature/summer_winter"
const FUTURE_PRECIPITATION = "feature/future/precipitation"
const FUTURE_SNOW = "feature/future/snow"
const FUTURE_SEA_TEMPERATURE = "feature/future/sea_temperature"
const EFFECT_RICE = "effect_and_measures/agriculture_forestry_fishing/future/agriculture/rice"
const EFFECT_FISHING = "effect_and_measures/agriculture_forestry_fishing/future/fishing"
const EFFECT_DAM = "effect_and_measures/water_env_resources/future/water_env/dam"
const EFFECT_PHENOLOGY = "effect_and_measures/ecosystem/history/phenology"
const EFFECT_TERRESTRIAL = "effect_and_measures/ecosystem/future/terrestrial"
const EFFECT_FLOOD = "effect_and_measures/natural_disasters_coastal_areas/future/river/flood"
const EFFECT_COASTAL_EROSION = "effect_and_measures/natural_disasters_coastal_areas/future/coast/coastal_erosion"
const EFFECT_DEBRIS_FLOW_LANDSLIDE = "effect_and_measures/natural_disasters_coastal_areas/future/mountain/debris_flow_landslide"
const EFFECT_HEAT_STROKE = "effect_and_measures/health/future/heat/heat_stroke"
const EFFECT_INFECTION = "effect_and_measures/health/future/infection"
const EFFECT_INDUSTRIAL_ECONOMIC_ACTIVITIES = "effect_and_measures/industrial_economic_activities"

const BASIC_PATHS = [
  NATURE, DEMOGRAPHY, DISASTER_RESPONSE, HISTORY_TEMP_YEARLY, HISTORY_PRECIPITATION, FUTURE_TEMP_AVERAGE, FUTURE_PRECIPITATION, EFFECT_RICE, EFFECT_FLOOD, EFFECT_HEAT_STROKE]

const SEA_PATHS = [
  NATURE, FISHING, DEMOGRAPHY, DISASTER_RESPONSE, HISTORY_TEMP_YEARLY, HISTORY_PRECIPITATION, FUTURE_TEMP_AVERAGE, FUTURE_PRECIPITATION, EFFECT_RICE, EFFECT_FISHING, EFFECT_FLOOD, EFFECT_COASTAL_EROSION, EFFECT_HEAT_STROKE]

const copyObject = (data) => {
  return Object.assign({}, JSON.parse(JSON.stringify(data)));
}

const CheckDocxInterface = ({ setting, setSetting }) => {
  const checkBasic = () => {
    const newSetting = copyObject(setting);
    const basicPathSet = new Set(BASIC_PATHS);

    for (const path in newSetting.contents) {
      newSetting.contents[path] = basicPathSet.has(path);
    }
    setSetting(newSetting);
  }

  const checkAll = () => {
    const newSetting = copyObject(setting);

    for (const path in newSetting.contents) {
      newSetting.contents[path] = true;
    }
    setSetting(newSetting);
  }

  return (
    <div className={styles.interface}>
      <input type="button" onClick={checkBasic} value="基本項目のみ" />
      <input type="button" onClick={checkAll} value="全て" />&nbsp;
    </div>
  )
}

export default hot(module)(CheckDocxInterface);
